import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import {SelectPublishingSystem} from "./SelectPublishingSystem";
import {PublishingStatusTable} from "./PublishingStatusTable";
import {useEffect, useState} from "react";
import {useSearchResultDetailsState} from "../search-result-details/SearchResultDetailsContext";

/**
 * Component for configuring settings for synchronization of objects from DAMS to 3rd party applications by
 * copying the DAMS object from EMSF to EMS.
 *
 * @param {Object} props - The component props.
 * @param {Object} props.model - The DAMS object.
 * @param {Function} props.t - Translation function for localized text.
 * @returns {React.JSX.Element} The rendered PublishData component.
 */
export const PublishData = ({model, t}) => {

    const [currentModel, setCurrentModel] = useState(undefined);
    const {model: stateModel} = useSearchResultDetailsState();

    useEffect(() => {
        if (stateModel) {
            // If handling an object from the search results, use that model.
            setCurrentModel(stateModel);
        } else if (model) {
            // If a model is passed as a prop, use that.
            setCurrentModel(model);
        }

        return () => {
            setCurrentModel(undefined);
        };
    }, [model, stateModel]);

    return <Box>
        <Typography variant="h5">
            {t('titlePublish', 'Publisering')}
        </Typography>
        <Typography>
            {t('subtitlePublish',
                'Publisering gjør filen tilgjengelig for bruk av andre systemer. ' +
                'Endringen kan ta noe tid,og status blir synlig først etter at ' +
                'mediaserveren har fullført operasjonen.')}
        </Typography>
        <SelectPublishingSystem t={t} model={currentModel}/>
        <PublishingStatusTable t={t} model={currentModel}/>
    </Box>;
};